import React from 'react';
import { Phone, Mail, MapPin } from 'lucide-react';
import { Button } from './ui/button';

const ContactSection = ({ contact }) => {
  return (
    <section
      id="contact"
      data-bg="light"
      className="bg-eos-grauhell text-eos-grauDunkel py-28"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Headline */}
        <div className="max-w-3xl mb-16">
          <h2 className="text-4xl lg:text-5xl font-semibold leading-tight">
            Projekt starten.
            <br />
            Strukturiert.
          </h2>

          <p className="mt-6 text-eos-grauDunkel/70 text-lg">
            Am Anfang steht kein Angebot.
            <br />
            Am Anfang steht ein strukturiertes Gespräch.
            <br />
            <br />
            Wir klären Anforderungen, Randbedingungen und Zielgrößen, bevor
            Lösungen entstehen.
          </p>
        </div>

        {/* Kontaktblöcke */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mb-16">
          <div>
            <Phone className="mb-4 text-eos-grauDunkel/60" />
            <p className="text-sm text-eos-grauDunkel/55">Telefon</p>
            <p className="mt-1">{contact.phone}</p>
          </div>

          <div>
            <Mail className="mb-4 text-eos-grauDunkel/60" />
            <p className="text-sm text-eos-grauDunkel/55">E-Mail</p>
            <p className="mt-1">{contact.email}</p>
          </div>

          <div>
            <MapPin className="mb-4 text-eos-grauDunkel/60" />
            <p className="text-sm text-eos-grauDunkel/55">Standort</p>
            <p className="mt-1 whitespace-pre-line">{contact.address}</p>
          </div>
        </div>

        {/* Abschluss / CTA */}
        <div className="border-t border-black/10 pt-10">
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
